import React from 'react';
import styles from '../OrderDetailsModal.module.scss';
import {EditIcon} from '../icons';
import ButtonWithIcon from 'components/ButtonWithIcon';
import {Prescription} from 'types';
import ProductItem from 'pages/RequestDetails/components/ProductItem';
import {WrenchIcon} from 'pages/Signup/icons';

interface ProductListProps {
  services: Prescription[] | undefined;
  onEditService: () => void;
  refetch: () => void;
}

const ProductList: React.FC<ProductListProps> = ({
  services,
  onEditService,
  refetch,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>
          <WrenchIcon width={24} height={24} color="#1A6AE5" />
          Services
        </h2>
        <ButtonWithIcon
          icon={<EditIcon width={16} height={16} />}
          color="ghost"
          size="md"
          onClick={onEditService}
        />
      </div>

      <div className={styles.productList}>
        {services?.map((service, index) => (
          <ProductItem
            disabledToCheck={false}
            selectedSplitItems={[]}
            setSelectedSplitItems={() => {}}
            key={`${service.id}-${index}`}
            product={service}
            refetch={refetch}
          />
        ))}
        {services?.length === 0 && (
          <p className={styles.no_products}>No services</p>
        )}
      </div>
    </div>
  );
};

export default ProductList;
